import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { useEffect } from "react";
import { useState } from "react";
import { Chip } from "@mui/material";

const BulkSelect1 = ({
  data, parentCallback, disabledval
}) => {

  const [personName, setPersonName] = React.useState([]);
  const [multiList, setMultiList] = useState([]);
  const [variants, setVariants] = React.useState([]);
  const [state, setState] = React.useState([]);
  const [targetid, setTargetId] = React.useState([]);
  // console.log("o0lo",targetid)
const sendData = () => {
    // parentCallback(variantName);
    parentCallback(targetid);
  };
  React.useEffect(async () => {
    sendData();
  }, [sendData]);
useEffect(()=>{
  setVariants(data)
},[data])
useEffect(()=>{
  let temp_arr=[]
  for (let i = 0; i < state.length; i++){
    temp_arr.push(state[i].id)
  }
  setTargetId(temp_arr)
},[state])
  return (
    <div className="w-100">
      <Autocomplete
      disabled={disabledval}
size="small"
        fullWidth
        value={state}
        onChange={(e, val) => {
          setState(val);
        }}
        multiple
        limitTags={2}
        id="multiple-limit-tags"
        options={variants}
        getOptionLabel={(option) => option.bulkGroupName}
        // defaultValue={mappingArray}
        renderInput={(params) => (
          <TextField
            // required
            // disabled={mappingDisable}
            size="small"
            fullWidth
            {...params}
            label="BulkGroup List"
            placeholder="BulkGroup List"
          />
        )}
      />
    </div>
  );
};

export default BulkSelect1;
